import React from "react";
import { Component } from "react";
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
//import axios from 'axios';
import Select from 'react-select';
import Modal from 'react-modal';

class About extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        }
    }

    closeAboutModal = () => {
        this.setState({ open: false });
    }

    handleAboutOpen = () => {
        this.setState({ open: true });
    }


    render() {
        return (
            <>
                <Modal
                    isOpen={this.state.open}
                    contentLabel="About Modal"
                    ariaHideApp={false}
                    backdrop="static"
                    style={{
                        content: {
                            top: '50%',
                            left: '50%',
                            right: 'auto',
                            bottom: 'auto',
                            backgroundColor: '#f0eee4',
                            marginRight: '-50%',
                            transform: 'translate(-50%, -50%)',
                            borderRadius: '10px',
                            padding: '10px',
                            width: '95%',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                        },
                    }}
                >
                    <div style={{ height: "90vh", marginTop: "5%", borderRadius: "10px", fontFamily:"lora"  }}>
                        <div style={{ textAlign: "center", fontStyle: "italic", color: "darkblue", fontSize: "25px", fontWeight: "bold", textShadow: "1px 1px 2px white", paddingBottom:"5px" }}>
                            <label> About iWash Laundry App</label></div>
                        <div style={{fontSize:"18px"}}>
                            <span style={{ textAlign: "left" }}><p>This app is designed to save you time while we provide a convenient and efficient laundry service to you.</p>
                                <p>Whether you are a busy individual, student, professional or family with less time for laundry obligations; with just a few taps, you can schedule pickups and
                                    deliveries, track your orders in real-time, and manage your laundry preferences - all from the comfort of your home or office.</p>
                                <p>Our user-friendly interface ensures a seamless experience, making laundry day a breeze.</p>
                                <p> Say goodbye to the hassle of traditional laundry methods and hello to more free time for the things that matter most to you.</p>
                            </span>
                            <div style={{ textAlign: "center" }}>
                                <span >Our moto: <b><em>"Do life, we do your laundry!"</em></b><br />
                                    <em>Powered by HudumaSoft | 079 637 2245</em><br /><br />
                                    <Button style={{ margin: "5px", color: "white", width:"80px" }} onClick={this.closeAboutModal} color='danger'>Close</Button>
                                </span>
                            </div>
                        </div>
                    </div>
                </Modal >
            </>
        );
    }
}
export default About